/*
 * Authors: mariushirjanu, Koen
 * Created: 10/03/2015
 * Upgraded: 27/12/2022
 */
import { util } from '../../../../shared/util';
import { Injectable } from '@angular/core';
import { ICatalogCategory, ICatalogProduct } from '../order-catalog-data.service';
import { INamedStringObject, INumericObject, IObject } from '../../../../../type_definitions/datatypes';
import { ICatalogLayout } from '../order-catalog.service';
import { GaEventService } from '../../../../shared/services/ga-event.service';
import { EVENT_ORDER_CATALOG_PRODUCTS_CHANGED } from '../../../../shared/app-events';
import { PriceCartService } from '../../cart/price-cart.service';
import { BuyingGuideModel } from '../guide/buying-guide.model';
import { MaxWidth } from '../../../../shared/responsive/responsive.service';

export enum CatalogCategoryType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}

@Injectable()
export class CatalogOverviewService {
  private _categoryCounts:INumericObject;
  private _filterCounts:IObject;
  private _products:ICatalogProduct[];
  private _numPages;
  private _state:IObject;
  private _selectedCategory:ICatalogCategory;

  constructor(
    private eventService:GaEventService,
    private priceCartService:PriceCartService,
    private buyingGuideModel:BuyingGuideModel
  ) {
    /***/
  }

  public set categoryCounts(categoryCounts:INumericObject) {
    this._categoryCounts = categoryCounts;
  }

  public get categoryCounts():INumericObject {
    return this._categoryCounts;
  }

  public set filterCounts(filterCounts:IObject) {
    this._filterCounts = filterCounts;
  }

  public get filterCounts():IObject {
    return this._filterCounts;
  }

  public set products(products:ICatalogProduct[]) {
    this._products = products;
    this.eventService.sendMessage(EVENT_ORDER_CATALOG_PRODUCTS_CHANGED, this._products);
  }

  public get products():ICatalogProduct[] {
    return this._products;
  }

  public set numPages(numPages:number){
    this._numPages = numPages;
  }

  public get numPages():number {
    return this._numPages;
  }

  public set state(state:IObject){
    this._state = state;
  }

  public get state():IObject {
    return this._state;
  }

  public set selectedCategory(selectedCategory:ICatalogCategory){
    this._selectedCategory = selectedCategory;
  }

  public get selectedCategory():ICatalogCategory {
    return this._selectedCategory;
  }

  public get possibleLayouts():ICatalogLayout[] {
    const productsPerPageA:{ options:number[]; current:number; } = {
      options: [
        10,
        15,
        25,
        50
      ],
      current: 10
    };
    const productsPerPageB:{ options:number[]; current:number; } = {
      options: [
        25,
        50,
        100
      ],
      current: 25
    };

    return [ {
      name: 'block',
      title: 'Block',
      icon: 'fa-th-list',
      width: MaxWidth.SM,
      productsPerPage: productsPerPageA
    }, {
      name: 'tab-light',
      title: 'Light',
      icon: 'fa-list',
      productsPerPage: productsPerPageA
    }, {
      name: 'tab-basic',
      title: 'Basic',
      icon: 'fa-align-justify',
      productsPerPage: productsPerPageB
    } ];
  }

  public get sortOptions():INamedStringObject[] {
    return [ {
      id: 'PRICE_ASC',
      name: 'Price ascending'
    }, {
      id: 'PRICE_DESC',
      name: 'Price descending'
    }, {
      id: 'CATEGORY',
      name: 'Category'
    }, {
      id: 'PART',
      name: 'Part#'
    }, {
      id: 'GLOBAL_PRT',
      name: 'Global Part#'
    }, {
      id: 'VENDOR',
      name: 'Vendor'
    }, {
      id: 'DESCR',
      name: 'Description'
    } ];
  }

  public getOrderDetailsSrefParams(productId:number, compatibleProductId?:number):IObject {
    const srefParams:IObject = {
      product: productId,
      guide: this.buyingGuideModel.searchCode()
    };

    if (compatibleProductId) {
      srefParams.compat = compatibleProductId;
    }

    return util.deepClone(srefParams); // remove undefined and return
  }

  public clear():void {
    this._products = undefined;
    this._categoryCounts = undefined;
    this._filterCounts = undefined;
    this._numPages = undefined;
    this._state = undefined;
    this._selectedCategory = undefined;
  }
}